// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"P2-z","colorTextValue":"Q2-z","swatches":"R2-z","collapseLink":"S2-z","isCollapsed":"T2-z","dropdown":"U2-z","disabled":"V2-z"};